import 'consumerweb-shim';
import 'core-js/stable'; // If imports from pp-react are required, please test this component on IE
import 'regenerator-runtime/runtime';
import React, { useEffect, useContext } from 'react';
import ReactDOM from 'react-dom';
import * as AppActions from '../../actions/AppActions';
import { hideSpinnerOverlay } from '../../utility/helper';
import FullPageError from './FullPageError';
import withTheme from '../../components/withTheme';
import Footer from '../../components/footer/footer';
import '../../../css/ppvx-app.less';
import {
  Context as WorldReadyContext,
  Message,
} from '@paypalcorp/worldready-react';
import withWorldReady from '../../components/withWorldReady';
import { MessageFormat } from '@paypalcorp/worldready';
import '../../vendor/datadog';
function InternalServerError() {
  useEffect(() => {
    AppActions.updateCurrentPage({ currentPage: 'landingError' });
    hideSpinnerOverlay();
  }, []);
  const worldReady = useContext(WorldReadyContext);
  const handleReturn = () => {
    window.location.pathname = new MessageFormat(worldReady, {
      id: 'errors.500.link.paypal',
    }).format();
  };
  return (
    <>
      <FullPageError
        showCloseButton={true}
        title={<Message id="errors.500.title" />}
        body={<Message id="errors.500.body" />}
        buttonLabel={<Message id="errors.500.returnTo" />}
        handleButtonClick={handleReturn}
        centerBody={true}
      />
      {new MessageFormat(worldReady, { id: 'errors.500.title' }).format() !==
        'errors.500.title' &&
        new MessageFormat(worldReady, { id: 'errors.500.body' }).format() !==
          'errors.500.body' && <Footer />}
    </>
  );
}
const InternalServerErrorWithTheme = withWorldReady(
  withTheme(InternalServerError)
);

ReactDOM.render(
  <InternalServerErrorWithTheme />,
  document.getElementById('donateWrapper')
);
